(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fado-minimal-card'))customElements.define('fado-minimal-card',class extends HTMLElement{
 connectedCallback(){
  const data=JSON.parse(this.querySelector('[data-card-variants]').textContent);
  this.addEventListener('click',event=>{
   const swatch=event.target.closest('[data-variant]');if(!swatch)return;
   const variant=data.variants.find(v=>String(v.id)===swatch.dataset.variant);if(!variant)return;
   this.querySelectorAll('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b===swatch)));
   this.querySelector('input[name="id"]').value=variant.id;
   this.querySelector('[data-price]').textContent=variant.price;
   const compare=this.querySelector('[data-compare]');compare.hidden=!variant.compare;compare.textContent=variant.compare||'';
   const add=this.querySelector('[name="add"]');add.disabled=!variant.available;add.removeAttribute('aria-disabled');
   this.querySelector('[data-add-label]').textContent=variant.available?data.add:data.sold;
   this.querySelector('[data-add-label]').classList.remove('hidden');this.querySelector('.sold-out-message').classList.add('hidden');
   this.querySelectorAll('a').forEach(a=>a.href=this.dataset.url+'?variant='+variant.id);
   if(variant.image){const track=this.querySelector('.fado-image-swipe__track');const img=track.querySelector('img');img.src=variant.image;img.removeAttribute('srcset');const second=track.querySelectorAll('img')[1];if(second){second.src=variant.second||variant.image;second.removeAttribute('srcset');}track.scrollLeft=0;}
  });
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fado-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fado-cart-recommendations')){
class FadoCartRecommendations extends HTMLElement{
 connectedCallback(){
  this.addEventListener('submit',this.add,true);
  if(typeof subscribe==='function')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,()=>this.refresh());
 }
 disconnectedCallback(){this.removeEventListener('submit',this.add,true);this.unsubscribe?.()}
 async refresh(){
  try{const response=await fetch(window.Shopify.routes.root+'cart?section_id='+this.dataset.section);const html=new DOMParser().parseFromString(await response.text(),'text/html');const replacement=html.querySelector('fado-cart-recommendations');if(replacement&&this.isConnected)this.replaceWith(replacement)}catch{}
 }
 add=async(event)=>{
  event.preventDefault();event.stopPropagation();const form=event.target,button=form.querySelector('button[type="submit"]');if(button.disabled)return;button.disabled=true;
  const status=this.querySelector('[role=status]');status.textContent='';
  let added=false;
  try{
   const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:form.elements.id.value,quantity:1}],sections:[this.dataset.section,'cart-icon-bubble'],sections_url:window.location.pathname})});
   const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||this.dataset.error);added=true;
   const doc=new DOMParser().parseFromString(data.sections[this.dataset.section],'text/html');
   const source=doc.querySelector('.fado-cart-page'),target=this.closest('.fado-cart-page');
   if(!source||!target)throw new Error(this.dataset.error);
   target.replaceWith(source);
   const bubbleDoc=new DOMParser().parseFromString(data.sections['cart-icon-bubble'],'text/html');const bubble=document.getElementById('cart-icon-bubble'),newBubble=bubbleDoc.getElementById('cart-icon-bubble');if(bubble&&newBubble)bubble.innerHTML=newBubble.innerHTML;
   const newStatus=source.querySelector('[role=status].fado-cart-picks__status');if(newStatus)newStatus.textContent=this.dataset.added;
   document.dispatchEvent(new CustomEvent('fado:cart-rendered'));
   source.querySelector('fado-cart-recommendations button')?.focus({preventScroll:true});
  }catch(error){if(added){window.location.reload();return}status.textContent=error.message||this.dataset.error;button.disabled=false}
 }
}
customElements.define('fado-cart-recommendations',FadoCartRecommendations);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fado-product-image-swipe"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fado-image-swipe'))customElements.define('fado-image-swipe',class extends HTMLElement{
 connectedCallback(){
  const track=this.querySelector('.fado-image-swipe__track'),indicators=this.querySelectorAll('.fado-image-swipe__indicators i');
  if(!track)return;
  let start=0,moved=false,mouse=false,left=0;
  this.addEventListener('pointerdown',e=>{start=e.clientX;moved=false;left=track.scrollLeft;mouse=e.pointerType==='mouse';if(mouse)track.style.scrollSnapType='none'});
  this.addEventListener('pointermove',e=>{if(e.buttons&&Math.abs(e.clientX-start)>7){moved=true;if(mouse)track.scrollLeft=left+start-e.clientX}});
  this.addEventListener('touchmove',()=>{moved=true},{passive:true});
  this.addEventListener('pointerup',()=>{if(mouse){track.style.scrollSnapType='';mouse=false}});
  this.addEventListener('dragstart',e=>e.preventDefault());
  this.addEventListener('click',e=>{if(moved){e.preventDefault();e.stopPropagation();moved=false}},true);
  this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();track.scrollBy({left:track.clientWidth*(e.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}});
  const update=()=>{const active=Math.round(track.scrollLeft/track.clientWidth);indicators.forEach((dot,index)=>dot.classList.toggle('is-active',index===active))};
  track.addEventListener('scroll',update,{passive:true});
  update();
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fado-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(){
    const bar=document.querySelector('.fado-sticky-atc');
    if(!bar||bar.dataset.ready)return;
    bar.dataset.ready='true';
    document.body.appendChild(bar);
    const button=bar.querySelector('button'),text=bar.querySelector('.fado-sticky-atc__label'),image=bar.querySelector('.fado-sticky-atc__image');
    const variants=JSON.parse(bar.querySelector('[data-sticky-variants]').textContent);
    let imageSource='';
    const getMain=()=>document.querySelector('[id^="ProductInfo-"] button[id^="ProductSubmitButton-"]');
    const sync=()=>{
      const main=getMain();
      const show=!!main&&main.getBoundingClientRect().bottom<=0;
      bar.hidden=!show;
      bar.setAttribute('aria-hidden',String(!show));
      if(main){
        button.disabled=main.disabled||main.getAttribute('aria-disabled')==='true';
        const label=main.querySelector('span')?.textContent.trim()||main.textContent.trim();
        if(text.textContent!==label)text.textContent=label;
        const variantId=main.closest('form')?.querySelector('[name="id"]')?.value||new URLSearchParams(location.search).get('variant')||bar.dataset.initialVariant;
        const variant=variants.find(item=>String(item.id)===String(variantId));
        const src=variant?.featured_image?.src||bar.dataset.defaultImage;
        if(image&&src&&src!==imageSource){imageSource=src;const url=new URL(src,location.origin);url.searchParams.set('width','160');image.removeAttribute('srcset');image.src=url.href;}
      }
    };
    button.addEventListener('click',()=>{const main=getMain();if(main&&!main.disabled)main.click();});
    let queued=false;
    const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;sync();});}};
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    const info=document.querySelector('[id^="ProductInfo-"]');
    if(info){new MutationObserver(schedule).observe(info,{childList:true,subtree:true,attributes:true,characterData:true});info.addEventListener('change',schedule);}
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fado-typography-refinement"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
 const input=event.target;
 if(!input.matches('variant-selects input[type="radio"][name^="Material-"]'))return;
 const description=input.labels?.[0]?.title;
 const info=input.closest('[id^="ProductInfo-"]');
 if(description&&info)info.querySelectorAll('[data-fado-material-detail]').forEach(node=>node.textContent=description);
});
  } catch(e) { console.error(e); }
})();

})();
